module.exports = "/_next/static/images/543443c82ab22032ea4cd7f9429f94cd-hero-md.jpg.webp";